<template>
  <div class="testType index-container">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    >
      <template #right>
        <div class="history-test" @click="growthRecord">历史测评</div>
      </template>
    </van-nav-bar>
    <!-- <present-children :typeCateegory='type' :disabled="type == 2" :showChildren='type == 2' :showTitle="showTitle" :children="children" :btnTitle="btnTitle" @growthRecord="growthRecord" @select="select($event)" :value="value" /> -->
    <div class="content">
      <div v-for="(item, index) in questionnaireList" :key="index">
        <div
          v-if="type != 3 || item.questionnaireUrl"
          class="screeningQuestion"
          @click="toTest(item, index)"
          :style="{ backgroundImage: 'url(' + coverImgUrl + ')' }"
        >
          <!-- <div class="dott" v-if="item&&item.num"><span>{{item.num}}</span></div> -->
          <!-- <img :src='question1' alt=""> -->
          <span>{{ item.name }}</span>
          <img
            class="rigth-arrow-big"
            src="../../assets/images/parent-course/rigth-arrow-big.png"
            alt=""
          />
        </div>
      </div>
      <div v-if="!questionnaireList.length && type == 3" class="nodata">
        暂无课程测试问卷，请先购买课程
      </div>
    </div>
  </div>
</template>

<script>
import presentChildren from "../../components/present-children/index.vue";
import { _category, courseQuestionnaireList } from "../../api/test-center";
import { decryptBy } from "@/assets/js/encryption";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { Toast } from "vant";
export default {
  components: { presentChildren },
  name: "test-type",
  data() {
    return {
      title: "儿童测试", //页面抬头
      type: "", //当前模式 1:家长测试，2:儿童测试
      questionnaireList: {}, //问卷列表
      coverImgUrl: "", //
      question1: "", //初筛问卷图片
      question2: "", //基线问卷图片
      questionnaire1: "", //
      questionnaire2: "", //
      questionnaire3: "", //
      btnTitle: "成长记录", //
      children: [],
      value: "",
      showTitle: true,
      paramsCategory: {
        childId: "", //儿童id
        parentId: "", //家长id
        useObject: "", //使用对象 1.学生 2.儿童 3.家长 4.社工 5.督导 6.教师
        resourceFrom: "", //数据来源：2、儿童测试 3、家长测试
      },
    };
  },
  watch: {},
  computed: {},
  created() {
    this.type = this.$route.query.type;
    let parentInfos = localStorage.getItem("userInfo");
    let resultParent = JSON.parse(decryptBy(parentInfos));
    if (localStorage.getItem("childId")) {
      this.value = localStorage.getItem("childId");
    }
    if (localStorage.getItem("children")) {
      if (decryptBy(localStorage.getItem("children"))) {
        this.children = JSON.parse(decryptBy(localStorage.getItem("children")));
      }
    }
    if (this.type != 3) {
      if (this.type == 1) {
        this.title = "自助测试";
        this.question1 = require("../../assets/images/test-center/parents-question.png");
        this.coverImgUrl = require("../../assets/images/test-center/parents-test.png");
        this.paramsCategory.parentId = resultParent.userId;
        this.paramsCategory.resourceFrom = "3";
        this.paramsCategory.childId = this.value;
        this.paramsCategory.useObject = 3;
      } else {
        this.title = "儿童功能自测量表";
        this.question1 = require("../../assets/images/test-center/kid-question1.png");
        this.coverImgUrl = require("../../assets/images/test-center/parents-test.png");
        this.paramsCategory.parentId = resultParent.userId;
        this.paramsCategory.resourceFrom = "4";
        this.paramsCategory.childId = "";
        this.paramsCategory.useObject = 4;
      }
      this.category(this.paramsCategory);
    } else {
      this.title = "课程考核";
      this.question1 = require("../../assets/images/test-center/parents-question.png");
      this.coverImgUrl = require("../../assets/images/test-center/parents-test.png");
      this.getCourseList();
    }
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    //获取课程列表
    getCourseList() {
      let parentInfos = localStorage.getItem("userInfo");
      let resultParent = JSON.parse(decryptBy(parentInfos));
      courseQuestionnaireList({
        asc: false,
        currentPage: 1,
        orderByField: "",
        pageSize: 9999,
        queryData: {
          ids: [],
          userId: "",
          childId: this.value,
          parentId: resultParent.userId,
        },
      }).then((res) => {
        if (res.code == 200) {
          res.data &&
            res.data.records.forEach((element) => {
              element.name = element.title;
            });
          this.questionnaireList = (res.data && res.data.records) || [];
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 返回按钮
    onClickLeft() {
      this.$router.push("testCenter");
    },
    // 成长记录
    growthRecord() {
      this.$router.push({
        path: "/growClub",
        query: {
          type: this.type,
        },
      });
      localStorage.setItem("childId", this.value);
    },
    // 选择当前儿童
    select(value) {
      this.value = value;
      localStorage.setItem("childId", this.value);
    },
    category(paramsCategory) {
      // let useObject;
      // if (this.type == 1) {
      // 	useObject = 3;
      // }else {
      // 	useObject = 2;
      // }
      _category(paramsCategory).then((res) => {
        if (res && res.code == 200) {
          this.questionnaireList = res.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 去问卷页
    toTest(val, index) {
      if (this.type != 3) {
        this.$router.push({
          path: "/testDetail",
          query: {
            investType: val.key,
            title: val.name,
            type: this.type,
          },
        });
      } else {
        this.$router.push({
          path: "/test",
          query: {
            type: 3, //数据来源：2、儿童测试 3、家长测试
            title: val.questionnaireName, // 量表名称
            key: val.questionnaireId, //量表的key
            projectUrl: val.questionnaireUrl, // 量表地址
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.testType {
  padding-bottom: 5px;
  .main-nav {
    position: fixed;
    width: 100%;
    top: 0;
    .history-test {
      width: 73px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      background: var(--btn-backgruond-color);
      border-radius: 999px;
      color: #ffffff;
    }
  }
}
.content {
  padding: 60px 20px 0;
  .nodata {
    text-align: center;
    color: #949c9d;
    margin-top: 100px;
    font-size: 14px;
  }
  .screeningQuestion {
    display: flex;
    align-items: center;
    width: 100%;
    height: 120px;
    background: #ffffff;
    // box-shadow: 0px 3px 8px 1px rgba(162, 162, 162, 0.2);
    border-radius: 16px;
    padding: 0 20px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom;
    margin-bottom: 20px;
    //line-height: 130px;
    position: relative;
    .dott {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(20%, -45%);
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: #ff5656;
      span {
        position: absolute;
        font-size: 12px;
        color: #ffffff;
        transform: translate(-150%, 0);
      }
    }
    img {
      vertical-align: middle;
      width: 81px;
      height: 85px;
    }
    span {
      margin-left: 20px;
      font-size: 16px;
    }
    .rigth-arrow-big {
      margin-left: 12px;
      width: 22px;
      height: 22px;
    }
  }
}
::v-deep .van-icon {
  color: #000;
}
::v-deep.el-select-dropdown.el-popper {
  left: 11px !important;
}
::v-deep
  .el-select
  .el-input.is-disabled
  .el-input__inner
  + .el-input__suffix
  .el-input__suffix-inner
  .el-select__caret {
  color: #ccc !important;
}
</style>
